import React from "react";
import { getOr } from "lodash/fp";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { addFestivalLinks } from "../../../../constants/linkDefinitions";
import Links from "../../../input/links/links";
import FormBox from "../../../presentational/page/formBox";
import { mainStateKey } from "../../../../constants/constants";
import SearchMissingLinkButton from "../../../presentational/buttons/searchMissingLinkButton";
import OpenAllLinksButton from "../../../presentational/buttons/openAllLinksButton";

const LinksBox = ({ festivalName, showOpenAllLinksButton = true }) => {
  const links = addFestivalLinks.mainLinks;
  const headerButtons = [
    <SearchMissingLinkButton key={1} connectedTo={"formData.links"} allEntityLinks={links} entityName={festivalName} />,
  ];

  if (showOpenAllLinksButton) {
    headerButtons.push(<OpenAllLinksButton key={2} connectedTo={"formData.links"} />);
  }

  return (
    <FormBox title="Links" headerContent={headerButtons}>
      <div className="box-body">
        <div className="form-horizontal">
          <Links
            linkInputData={links}
            name="formData.links"
            entityName={festivalName}
            oldLinksName="formData.oldLinks"
          />
        </div>
      </div>
    </FormBox>
  );
};

const mapStateToProps = state => {
  return { festivalName: getOr(null, `${mainStateKey}.formData.name.name`, state) };
};

LinksBox.propTypes = {
  festivalName: PropTypes.string,
  showOpenAllLinksButton: PropTypes.bool,
};

export default connect(mapStateToProps)(LinksBox);
